import { axiosBase } from 'utils';

export function wifiusersListService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/wifiusers',
  });
}

export function wifiusersListByIdService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/wifiusers/' + id,
  });
}

export function wifiusersCreateService(values) {
  const axios = axiosBase.create();
  return axios({
    method: 'POST',
    url: '/wifiusers',
    data: {
      username: values.username,
      password: values.password,
      fullname: values.fullname,
      wifigroup: values.wifigroup,
      status: values.status,
      usercount: values.usercount,
      showInDirectory: values.showInDirectory ? 'Y' : 'N',
      phone: values.phone,
      email: values.email,
      email_user_wifi_details: values.email_user_wifi_details,
    },
  });
}

export function wifiusersImportService(values) {
  const axios = axiosBase.create();
  return axios({
    method: 'POST',
    url: '/wifiusers/import',
    data: values,
  });
}

export function wifiusersUpdateService(id, values) {
  const axios = axiosBase.create();
  return axios({
    method: 'PATCH',
    url: '/wifiusers/' + id,
    data: {
      username: values.username,
      password: values.password,
      fullname: values.fullname,
      wifigroup: values.wifigroup,
      status: values.status,
      usercount: values.usercount,
      showInDirectory: values.showInDirectory ? 'Y' : 'N',
      phone: values.phone,
      email: values.email,
      email_user_wifi_details: values.email_user_wifi_details,
    },
  });
}

export function wifiusersDeleteService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'DELETE',
    url: '/wifiusers/' + id,
  });
}

export function wifiusersSearchService(q, paginationPayload) {
  const axios = axiosBase.create();
  //console.log("paginationPayload", paginationPayload);
  let paginationQuery = '';
  if (paginationPayload) {
    paginationQuery = new URLSearchParams(paginationPayload).toString();
  }
  return axios({
    method: 'GET',
    url: '/wifiusers/search?q=' + q + '&' + paginationQuery,
  });
}

export function wifiusersSuperAdminSearchService(q, paginationPayload) {
  const axios = axiosBase.create();
  let paginationQuery = '';
  if (paginationPayload) {
    paginationQuery = new URLSearchParams(paginationPayload).toString();
  }
  const queryString = q ? `q=${encodeURIComponent(q)}` : '';
  const finalQuery = paginationQuery
    ? `${queryString}&${paginationQuery}`
    : queryString;
  const url = `/wifiusers/search/super-admin${
    finalQuery ? '?' + finalQuery : ''
  }`;

  return axios({
    method: 'GET',
    url: url,
  });
}
